import { createRoute } from '@tanstack/solid-router'
import { appLayoutRoute } from '../app-layout.route'
import { TasksPage } from '../../Views'

export const tasksRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/tasks',
  component: TasksPage,
})
